<template>
  <div class="bids-download">
    <a class="download-title ellipsis--l1" target="_blank" :href="value.url" :download="value.title || value.url" @click="downloadClick">
      <slot>{{ value.title }}</slot>
    </a>
    <a class="download-button" target="_blank" :href="value.url" :download="value.title || value.url" @click="downloadClick">
      <img class="icon-download" src="@/assets/images/icon-download.png">{{ buttonText }}
    </a>
  </div>
</template>

<script>
import { templateDownloadAmount } from '@/api'

export default {
  props: {
    value: {
      type: Object,
      default() {
        return {}
      }
    },
    buttonText: {
      type: String,
      default: '下载'
    }
  },

  methods: {
    downloadClick() {
      templateDownloadAmount({
        id: this.value.id
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.bids-download {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .download-button {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    color: #417EF7;
    padding: 0;
    text-decoration: none;
    cursor: pointer;
    .icon-download {
      margin: 0 4px 0 0;
    }
  }
}
</style>
